import { ReactComponent as ImageDeleteSvg } from "../../assets/images/svgs/imageDelete.svg";

const ImageDeleteIcon = ({ className = "", ...props }) => {
  return (
    <ImageDeleteSvg
      className={className}
      focusable="false"
      aria-hidden="true"
      {...props}
    />
  );
};

export default ImageDeleteIcon;
